module.exports = "<div class=\"container\">\n  <div class=\"jumbotron\">\n    <h1 class=\"text-center\" style=\"color: #8a6d3b; margin: auto\">Oops!</h1>\n    <h2 class=\"text-center\" style=\"color: #8a6d3b; margin: auto\">Página não encontrada!</h2>\n    <br>\n    <button class=\"btn btn-outline-warning float-right\" routerLink=\"/help\">Voltar à Página Inicial</button>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/not-found/not-found.component.html
// module id = 185
// module chunks = 1